import _toConsumableArray from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _slicedToArray from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.array.flat.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __defProp = Object.defineProperty;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __publicField = function __publicField(obj, key, value) {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

  return value;
};

var __accessCheck = function __accessCheck(obj, member, msg) {
  if (!member.has(obj)) throw TypeError("Cannot " + msg);
};

var __privateGet = function __privateGet(obj, member, getter) {
  __accessCheck(obj, member, "read from private field");

  return getter ? getter.call(obj) : member.get(obj);
};

var __privateAdd = function __privateAdd(obj, member, value) {
  if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};

var __privateSet = function __privateSet(obj, member, value, setter) {
  __accessCheck(obj, member, "write to private field");

  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};

var _parts, _processor, _items, _value, _element, _attributeName, _namespaceURI, _list, list_get, _parentNode, _nodes;

import { globalThis } from "../utils/server-safe-globals.js";
var ELEMENT = 1;
var STRING = 0;
var PART = 1;
var defaultProcessor = {
  processCallback: function processCallback(instance, parts, state) {
    if (!state) return;

    var _iterator = _createForOfIteratorHelper(parts),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
            expression = _step$value[0],
            part = _step$value[1];

        if (expression in state) {
          var value = state[expression];

          if (typeof value === "boolean" && part instanceof AttrPart && typeof part.element[part.attributeName] === "boolean") {
            part.booleanValue = value;
          } else if (typeof value === "function" && part instanceof AttrPart) {
            part.element[part.attributeName] = value;
          } else {
            part.value = value;
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
};

var TemplateInstance = /*#__PURE__*/function (_globalThis$DocumentF) {
  _inherits(TemplateInstance, _globalThis$DocumentF);

  var _super = _createSuper(TemplateInstance);

  function TemplateInstance(template, state) {
    var _this;

    var processor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultProcessor;

    _classCallCheck(this, TemplateInstance);

    var _a;

    _this = _super.call(this);

    __privateAdd(_assertThisInitialized(_this), _parts, void 0);

    __privateAdd(_assertThisInitialized(_this), _processor, void 0);

    _this.append(template.content.cloneNode(true));

    __privateSet(_assertThisInitialized(_this), _parts, parse(_assertThisInitialized(_this)));

    __privateSet(_assertThisInitialized(_this), _processor, processor);

    (_a = processor.createCallback) == null ? void 0 : _a.call(processor, _assertThisInitialized(_this), __privateGet(_assertThisInitialized(_this), _parts), state);
    processor.processCallback(_assertThisInitialized(_this), __privateGet(_assertThisInitialized(_this), _parts), state);
    return _this;
  }

  _createClass(TemplateInstance, [{
    key: "update",
    value: function update(state) {
      __privateGet(this, _processor).processCallback(this, __privateGet(this, _parts), state);
    }
  }]);

  return TemplateInstance;
}(globalThis.DocumentFragment);

_parts = new WeakMap();
_processor = new WeakMap();

var parse = function parse(element) {
  var parts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var type, value;

  var _iterator2 = _createForOfIteratorHelper(element.attributes || []),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var attr = _step2.value;

      if (attr.value.includes("{{")) {
        var list = new AttrPartList();

        var _iterator4 = _createForOfIteratorHelper(tokenize(attr.value)),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _step4$value = _slicedToArray(_step4.value, 2);

            type = _step4$value[0];
            value = _step4$value[1];
            if (!type) list.append(value);else {
              var part = new AttrPart(element, attr.name, attr.namespaceURI);
              list.append(part);
              parts.push([value, part]);
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }

        attr.value = list.toString();
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  var _iterator3 = _createForOfIteratorHelper(element.childNodes),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var node = _step3.value;

      if (node.nodeType === ELEMENT && !(node instanceof HTMLTemplateElement)) {
        parse(node, parts);
      } else {
        if (node.nodeType === ELEMENT || node.data.includes("{{")) {
          var items = [];

          if (node.data) {
            var _iterator5 = _createForOfIteratorHelper(tokenize(node.data)),
                _step5;

            try {
              for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                var _step5$value = _slicedToArray(_step5.value, 2);

                type = _step5$value[0];
                value = _step5$value[1];
                if (!type) items.push(new Text(value));else {
                  var _part = new ChildNodePart(element);

                  items.push(_part);
                  parts.push([value, _part]);
                }
              }
            } catch (err) {
              _iterator5.e(err);
            } finally {
              _iterator5.f();
            }
          } else if (node instanceof HTMLTemplateElement) {
            var _part2 = new InnerTemplatePart(element, node);

            items.push(_part2);
            parts.push([_part2.expression, _part2]);
          }

          node.replaceWith.apply(node, _toConsumableArray(items.flatMap(function (part) {
            return part.replacementNodes || [part];
          })));
        }
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return parts;
};

var mem = {};

var tokenize = function tokenize(text) {
  var value = "",
      open = 0,
      tokens = mem[text],
      i = 0,
      c;
  if (tokens) return tokens;else tokens = [];

  for (; c = text[i]; i++) {
    if (c === "{" && text[i + 1] === "{" && text[i - 1] !== "\\" && text[i + 2] && ++open == 1) {
      if (value) tokens.push([STRING, value]);
      value = "";
      i++;
    } else if (c === "}" && text[i + 1] === "}" && text[i - 1] !== "\\" && ! --open) {
      tokens.push([PART, value.trim()]);
      value = "";
      i++;
    } else value += c || "";
  }

  if (value) tokens.push([STRING, (open > 0 ? "{{" : "") + value]);
  return mem[text] = tokens;
};

var FRAGMENT = 11;

var Part = /*#__PURE__*/function () {
  function Part() {
    _classCallCheck(this, Part);
  }

  _createClass(Part, [{
    key: "value",
    get: function get() {
      return "";
    },
    set: function set(val) {}
  }, {
    key: "toString",
    value: function toString() {
      return this.value;
    }
  }]);

  return Part;
}();

var attrPartToList = /* @__PURE__ */new WeakMap();

var AttrPartList = /*#__PURE__*/function () {
  function AttrPartList() {
    _classCallCheck(this, AttrPartList);

    __privateAdd(this, _items, []);
  }

  _createClass(AttrPartList, [{
    key: Symbol.iterator,
    value: function value() {
      return __privateGet(this, _items).values();
    }
  }, {
    key: "length",
    get: function get() {
      return __privateGet(this, _items).length;
    }
  }, {
    key: "item",
    value: function item(index) {
      return __privateGet(this, _items)[index];
    }
  }, {
    key: "append",
    value: function append() {
      for (var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++) {
        items[_key] = arguments[_key];
      }

      for (var _i = 0, _items2 = items; _i < _items2.length; _i++) {
        var item = _items2[_i];

        if (item instanceof AttrPart) {
          attrPartToList.set(item, this);
        }

        __privateGet(this, _items).push(item);
      }
    }
  }, {
    key: "toString",
    value: function toString() {
      return __privateGet(this, _items).join("");
    }
  }]);

  return AttrPartList;
}();

_items = new WeakMap();

var AttrPart = /*#__PURE__*/function (_Part) {
  _inherits(AttrPart, _Part);

  var _super2 = _createSuper(AttrPart);

  function AttrPart(element, attributeName, namespaceURI) {
    var _this2;

    _classCallCheck(this, AttrPart);

    _this2 = _super2.call(this);

    __privateAdd(_assertThisInitialized(_this2), _list);

    __privateAdd(_assertThisInitialized(_this2), _value, "");

    __privateAdd(_assertThisInitialized(_this2), _element, void 0);

    __privateAdd(_assertThisInitialized(_this2), _attributeName, void 0);

    __privateAdd(_assertThisInitialized(_this2), _namespaceURI, void 0);

    __privateSet(_assertThisInitialized(_this2), _element, element);

    __privateSet(_assertThisInitialized(_this2), _attributeName, attributeName);

    __privateSet(_assertThisInitialized(_this2), _namespaceURI, namespaceURI);

    return _this2;
  }

  _createClass(AttrPart, [{
    key: "attributeName",
    get: function get() {
      return __privateGet(this, _attributeName);
    }
  }, {
    key: "attributeNamespace",
    get: function get() {
      return __privateGet(this, _namespaceURI);
    }
  }, {
    key: "element",
    get: function get() {
      return __privateGet(this, _element);
    }
  }, {
    key: "value",
    get: function get() {
      return __privateGet(this, _value);
    },
    set: function set(newValue) {
      if (__privateGet(this, _value) === newValue) return;

      __privateSet(this, _value, newValue);

      if (!__privateGet(this, _list, list_get) || __privateGet(this, _list, list_get).length === 1) {
        if (newValue == null) {
          __privateGet(this, _element).removeAttributeNS(__privateGet(this, _namespaceURI), __privateGet(this, _attributeName));
        } else {
          __privateGet(this, _element).setAttributeNS(__privateGet(this, _namespaceURI), __privateGet(this, _attributeName), newValue);
        }
      } else {
        __privateGet(this, _element).setAttributeNS(__privateGet(this, _namespaceURI), __privateGet(this, _attributeName), __privateGet(this, _list, list_get));
      }
    }
  }, {
    key: "booleanValue",
    get: function get() {
      return __privateGet(this, _element).hasAttributeNS(__privateGet(this, _namespaceURI), __privateGet(this, _attributeName));
    },
    set: function set(value) {
      if (!__privateGet(this, _list, list_get) || __privateGet(this, _list, list_get).length === 1) this.value = value ? "" : null;else throw new DOMException("Value is not fully templatized");
    }
  }]);

  return AttrPart;
}(Part);

_value = new WeakMap();
_element = new WeakMap();
_attributeName = new WeakMap();
_namespaceURI = new WeakMap();
_list = new WeakSet();

list_get = function list_get() {
  return attrPartToList.get(this);
};

var ChildNodePart = /*#__PURE__*/function (_Part2) {
  _inherits(ChildNodePart, _Part2);

  var _super3 = _createSuper(ChildNodePart);

  function ChildNodePart(parentNode, nodes) {
    var _this3;

    _classCallCheck(this, ChildNodePart);

    _this3 = _super3.call(this);

    __privateAdd(_assertThisInitialized(_this3), _parentNode, void 0);

    __privateAdd(_assertThisInitialized(_this3), _nodes, void 0);

    __privateSet(_assertThisInitialized(_this3), _parentNode, parentNode);

    __privateSet(_assertThisInitialized(_this3), _nodes, nodes ? _toConsumableArray(nodes) : [new Text()]);

    return _this3;
  }

  _createClass(ChildNodePart, [{
    key: "replacementNodes",
    get: function get() {
      return __privateGet(this, _nodes);
    }
  }, {
    key: "parentNode",
    get: function get() {
      return __privateGet(this, _parentNode);
    }
  }, {
    key: "nextSibling",
    get: function get() {
      return __privateGet(this, _nodes)[__privateGet(this, _nodes).length - 1].nextSibling;
    }
  }, {
    key: "previousSibling",
    get: function get() {
      return __privateGet(this, _nodes)[0].previousSibling;
    }
  }, {
    key: "value",
    get: function get() {
      return __privateGet(this, _nodes).map(function (node) {
        return node.textContent;
      }).join("");
    },
    set: function set(newValue) {
      this.replace(newValue);
    }
  }, {
    key: "replace",
    value: function replace() {
      for (var _len2 = arguments.length, nodes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        nodes[_key2] = arguments[_key2];
      }

      var normalisedNodes = nodes.flat().flatMap(function (node) {
        return node == null ? [new Text()] : node.forEach ? _toConsumableArray(node) : node.nodeType === FRAGMENT ? _toConsumableArray(node.childNodes) : node.nodeType ? [node] : [new Text(node)];
      });
      if (!normalisedNodes.length) normalisedNodes.push(new Text());

      __privateSet(this, _nodes, swapdom(__privateGet(this, _nodes)[0].parentNode, __privateGet(this, _nodes), normalisedNodes, this.nextSibling));
    }
  }]);

  return ChildNodePart;
}(Part);

_parentNode = new WeakMap();
_nodes = new WeakMap();

var InnerTemplatePart = /*#__PURE__*/function (_ChildNodePart) {
  _inherits(InnerTemplatePart, _ChildNodePart);

  var _super4 = _createSuper(InnerTemplatePart);

  function InnerTemplatePart(parentNode, template) {
    var _this4;

    _classCallCheck(this, InnerTemplatePart);

    var directive = template.getAttribute("directive") || template.getAttribute("type");
    var expression = template.getAttribute("expression") || template.getAttribute(directive) || "";
    if (expression.startsWith("{{")) expression = expression.trim().slice(2, -2).trim();
    _this4 = _super4.call(this, parentNode);

    __publicField(_assertThisInitialized(_this4), "directive");

    _this4.expression = expression;
    _this4.template = template;
    _this4.directive = directive;
    return _this4;
  }

  return InnerTemplatePart;
}(ChildNodePart);

function swapdom(parent, a, b) {
  var end = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var i = 0,
      cur,
      next,
      bi,
      n = b.length,
      m = a.length;

  while (i < n && i < m && a[i] == b[i]) {
    i++;
  }

  while (i < n && i < m && b[n - 1] == a[m - 1]) {
    end = b[(--m, --n)];
  }

  if (i == m) while (i < n) {
    parent.insertBefore(b[i++], end);
  }
  if (i == n) while (i < m) {
    parent.removeChild(a[i++]);
  } else {
    cur = a[i];

    while (i < n) {
      bi = b[i++], next = cur ? cur.nextSibling : end;
      if (cur == bi) cur = next;else if (i < n && b[i] == next) parent.replaceChild(bi, cur), cur = next;else parent.insertBefore(bi, cur);
    }

    while (cur != end) {
      next = cur.nextSibling, parent.removeChild(cur), cur = next;
    }
  }
  return b;
}

export { AttrPart, AttrPartList, ChildNodePart, InnerTemplatePart, Part, TemplateInstance, defaultProcessor, parse, tokenize };